module.exports = __webpack_public_path__ + "static/media/bat-2.64d776c6.gif";